// Function to initialize size guide
function initSizeGuide() {
    let popup = document.querySelector(".size-popup");
    
    if (!popup) return;
    
    let inner = popup.querySelector(".inner");
    if (!inner) return;

    // Move popup to body if not already there
    if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
    }
    
    let sizeBtnClose = popup.querySelector(".close");

    let scrollPosition = 0;
    let previousOverlflow = "";
    let previousPosition = "";

    // Prevent clicks inside popup from closing it
    inner.addEventListener("click", function (e) {
        e.stopPropagation();
    });

    // Click outside to close
    popup.addEventListener("click", function () {
        close();
    });

    // Close function
    function close() {
        popup.classList.remove("show");
        let body = document.body;
        setTimeout(() => {
            let content = popup.querySelector('.content');
            if (content) content.scrollTop = 0;
        }, 200);
        body.style.overflow = previousOverlflow;
        body.style.position = previousPosition;
        body.style.top = 0;
        window.scrollTo(0, scrollPosition);
    }

    // Close button handler
    if (sizeBtnClose) {
        sizeBtnClose.addEventListener("click", function () {
            close();
        });
    }

    // Use event delegation for size guide trigger buttons
    document.addEventListener("click", function (e) {
        // Check if clicked element or its parent is the trigger button
        let trigger = e.target.closest(".trigger_size_guide");
        
        if (trigger) {
            e.preventDefault();
            popup.classList.add("show");

            let body = document.body;

            scrollPosition = window.scrollY;
            previousOverlflow = body.style.overflow;
            previousPosition = body.style.position;

            body.style.overflow = "hidden";
            // body.style.position = "fixed";
            // body.style.top = -scrollPosition + "px";
        }
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
} else {
    initSizeGuide();
}

// Re-initialize if new content is loaded (for AJAX navigation)
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSizeGuide);
}
